// A glyph of the design system (web/tokens/glyphs.css, DESIGN_SYSTEM.md section 7). It always stands beside a
// word, so it is hidden from assistive technology. The map names complete classes: scripts/check-classes.mjs
// sees complete names only, never a name assembled at run time.

const glyphClass = {
  answer: "sf-glyph--answer",
  blocker: "sf-glyph--blocker",
  calendar: "sf-glyph--calendar",
  check: "sf-glyph--check",
  clock: "sf-glyph--clock",
  close: "sf-glyph--close",
  cornerClosed: "sf-glyph--corner-closed",
  cornerOpen: "sf-glyph--corner-open",
  excl: "sf-glyph--excl",
  home: "sf-glyph--home",
  inbox: "sf-glyph--inbox",
  incl: "sf-glyph--incl",
  increase: "sf-glyph--increase",
  info: "sf-glyph--info",
  ledger: "sf-glyph--ledger",
  menu: "sf-glyph--menu",
  more: "sf-glyph--more",
  nstat: "sf-glyph--nstat",
  question: "sf-glyph--question",
  queue: "sf-glyph--queue",
  risk: "sf-glyph--risk",
  deviation: "sf-glyph--deviation",
  source: "sf-glyph--source",
  uncl: "sf-glyph--uncl",
} as const;

export type GlyphName = keyof typeof glyphClass;

export function Glyph({ name, className }: { name: GlyphName; className?: string }) {
  return <i className={`sf-glyph ${glyphClass[name]}${className === undefined ? "" : ` ${className}`}`} aria-hidden="true" />;
}
